import InfiniteScroll from 'react-infinite-scroller'
import { NoData } from 'components/NoData'
import { MobileCardWrap } from './styles'

interface IProps {
  dataSource: Array<{
    [key: string]: any
  }>
  onScrollEnd?: () => void
  hasMore?: boolean
  renderItem: (row: any) => any
}

const MobileTableList = ({
  dataSource,
  onScrollEnd,
  hasMore,

  renderItem,
}: IProps) => {
  return (
    <MobileCardWrap id="mobile-infinite-scroll-wrap">
      {dataSource?.length > 0 && (
        <InfiniteScroll
          pageStart={0}
          loadMore={() => {
            if (typeof onScrollEnd === 'function' && hasMore) {
              onScrollEnd()
            }
          }}
          threshold={50}
          hasMore={hasMore}
          getScrollParent={() =>
            document.getElementById('mobile-infinite-scroll-wrap')
          }
          useWindow={false}
        >
          {dataSource.map((row, rowIndex) => {
            return <div key={rowIndex}>{renderItem(row)}</div>
          })}
        </InfiniteScroll>
      )}
      {dataSource?.length === 0 && <NoData />}
    </MobileCardWrap>
  )
}

export default MobileTableList
